// extracted by mini-css-extract-plugin
export var description = "Table-module--description--oeSiw";
export var table = "Table-module--table--xTaZJ";